<template>
  <div class="dropdown-multiple-member-select-menu-button-wrap">
    <p class="title">{{ $t(title) }}<span v-if="required">*</span></p>
    <ValidationProvider v-slot="{ errors }" :rules="rules" class="dropdown-wrap">
      <div
        v-click-outside="$_dropdownClose"
        class="dropdown-multiple-member-select-menu-button"
        :class="{
          outline: outline,
          narrow: narrow,
          wide: wide,
          error: errors.length > 0,
          selected: value.length > 0,
        }"
      >
        <input type="hidden" :value="value" />
        <i v-if="leadingIcon" class="icon leading-icon" :class="leadingIcon" />
        <button class="input-button" @click="$_onclick()">
          <p class="input-button_text">
            {{ _selectName }}
          </p>
        </button>
        <i
          v-if="outline"
          class="icon trailing-icon outline icon-chevron-up"
          :class="{ show: dropdown_menu_show }"
        />
        <i
          v-else-if="!outline && !dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-down-circle"
        />
        <i
          v-else-if="!outline && dropdown_menu_show"
          class="icon trailing-icon icon-arrow-drop-up-circle"
        />
        <div class="dropdown-menu" :class="{ show: dropdown_menu_show, priority: priority }">
          <div class="search-tool">
            <SearchInput
              v-model="searchInputButton.value"
              :placeholder="searchInputButton.placeholder"
              :text-label="searchInputButton.textLabel"
              @enter="$_searchDropdown()"
            />
          </div>
          <perfect-scrollbar
            v-scroll:throttle="{ fn: $_onScroll, throttle: 32 }"
            class="ps dropdown-scrollable-content"
          >
            <div v-for="(item, item_k) in _dropdownItems" :key="item_k" class="dropdown-menu-item">
              <label>
                <input
                  v-model="_checkedValue"
                  type="checkbox"
                  :value="item.id"
                  @change="$_checkboxOnchange()"
                />
                <p>{{ item.name }}</p>
                <div class="checkbox-icon">
                  <i class="checked icon-check-box" />
                  <i class="unchecked icon-check-box-outline-blank" />
                </div>
              </label>
            </div>
          </perfect-scrollbar>
          <div v-if="priority" class="add-btn" @click="$_addMemberOpen()">
            <WsTextButton001 leading-icon="icon-add-circle" primary>
              {{ addTextLabel }}
            </WsTextButton001>
          </div>
        </div>
        <div v-if="addMemberActive" class="dropdown-menu" :class="{ show: addMemberActive }">
          <div class="menu-title">
            <i class="icon-arrow-left" @click="$_addMemberClose()" />
            <p>{{ addTextLabel }}</p>
          </div>
          <div class="dropdown-content">
            <StateInputButton
              v-for="(fieldItem, fieldKey) in addFieldsType"
              :key="fieldKey"
              v-model="addFields[fieldKey]"
              :title="fieldItem.title"
              :placeholder="fieldItem.placeholder"
              required
              :rules="fieldItem.rules"
            />
            <div class="btns">
              <div class="btn">
                <WsButton001 out-line narrow>
                  {{ $t('取消') }}
                </WsButton001>
              </div>
              <div class="btn">
                <WsButton001 @click="$_addSubmitClick()">
                  {{ $t('送出') }}
                </WsButton001>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="errors.length > 0" class="invalid-text">
        <i class="icon-warning invalid-icon" />
        <p v-for="(text_e, text_k) in errors" :key="text_k" class="text">
          {{ $t(text_e) }}
        </p>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import { ValidationProvider } from 'vee-validate';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import H_user from '@/helpers/user';

extend('required', {
  ...required,
  message: '此項目為必填',
});
export default {
  name: 'DropdownMultipleMemberSelectMenuButton',
  directives: {
    ClickOutside,
  },
  components: {
    ValidationProvider,
  },
  props: {
    leadingIcon: {
      type: String,
      default: '',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    selectValue: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    addTextLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dropdown_menu_show: false,
      searchInputButton: {
        value: '',
        placeholder: this.$t('搜尋'),
        textLabel: this.$t('搜尋'),
      },
      addMemberActive: false,
      addName: '',
      addEmail: '',
      position: { scrollTop: 0, scrollLeft: 0 },
      scrollTotalHeight: 0,
      windowTotalHeight: 0,
      currentPage: 1,
      lastPage: 1,
      dropdownMenuItem: [],
      contrastDropdownMenuItem: [],
      addFields: {},
      addFieldsType: {},
      memberFields: {
        name: '',
        email: '',
      },
      memberFieldsType: {
        name: {
          title: this.$t('人員名稱'),
          placeholder: this.$t('輸入'),
          rules: 'required',
        },
        email: {
          title: this.$t('信箱'),
          placeholder: this.$t('請輸入電子信箱'),
          rules: 'required|email',
        },
      },
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$store.state.app.factoryId;
    },
    _checkedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.checked_proxy = val;
      },
    },
    _selectName() {
      if (!this.contrastDropdownMenuItem) return;
      if (this.value.length == 0) {
        return this.$t(this.placeholder);
      }
      let selectValue = this.contrastDropdownMenuItem.filter(item => this.value.includes(item.id));
      let allSelectName = selectValue.map(value => value.name);
      return allSelectName.join(', ');
    },
    _remainNumber() {
      let selectNumber = this.value.length;
      let remainNumber;
      if (selectNumber > 3) {
        remainNumber = selectNumber - 3;
      } else {
        return;
      }
      return '+' + remainNumber;
    },
    _dropdownItems() {
      return this.dropdownMenuItem;
    },
  },
  mounted() {
    this.$_getDropdownMenu();
    this.$_getAddField();
  },
  methods: {
    $_getAddField() {
      this.addFields = this.memberFields;
      this.addFieldsType = this.memberFieldsType;
    },
    $_onScroll(e, position) {
      this.scrollTotalHeight = e.target.scrollHeight;
      this.windowTotalHeight = e.target.offsetHeight;
      this.position = position;
      this.$_scrollBottomGetDropdown();
    },
    $_onclick() {
      this.$_toggleDropdownMenuShow();
    },
    $_toggleDropdownMenuShow() {
      this.dropdown_menu_show = !this.dropdown_menu_show;
    },
    $_dropdownClose() {
      this.dropdown_menu_show = false;
      this.addMemberActive = false;
      this.searchInputButton.value = '';
    },
    $_addMemberOpen() {
      this.addMemberActive = true;
      this.dropdown_menu_show = false;
    },
    $_addMemberClose() {
      this.addMemberActive = false;
      this.dropdown_menu_show = true;
    },
    $_checkboxOnchange() {
      this.$emit('input', this.checked_proxy);
    },
    $_searchDropdown() {
      this.$_getDropdownMenu('search');
    },
    $_searchMemberByName() {
      let originalItems = [...this.dropdownMenuItem];
      if (this.searchInputButton.value) {
        let searchOrigianlItems = originalItems.filter(item =>
          item.name.toLowerCase().includes(this.searchInputButton.value.toLowerCase()),
        );
        return searchOrigianlItems;
      }
      return originalItems;
    },
    async $_getDropdownMenu(type) {
      try {
        if (type === 'search') {
          this.currentPage = 1;
        }
        const params = {
          page: this.currentPage,
          search: this.searchInputButton.value,
        };
        const res = await this.$axios.get(
          `/factory/${this._currentFactoryId}/simplify_factory_index`,
          {
            params: params,
          },
        );
        let members = H_user.setDropdownMenuList(res.data.data);
        this.lastPage = res.data.meta.last_page;
        if (type === 'search') {
          this.dropdownMenuItem = members;
        } else {
          this.dropdownMenuItem = this.dropdownMenuItem.concat(members);
          this.contrastDropdownMenuItem = this.dropdownMenuItem;
          this.selectValue.forEach(value => {
            let selectInContrast = this.contrastDropdownMenuItem.find(item => item.id === value.id);
            if (!selectInContrast) {
              this.contrastDropdownMenuItem.push(value);
            }
          });
        }
      } catch (err) {
        alert(err);
      }
    },
    async $_addSubmitClick() {
      const isValidate = await this.$refs.memberObserver.validate();
      if (!isValidate) {
        return;
      }
      let getUrl = '';
      if (this.type === 'contractor') {
        getUrl = `/factory/${this._currentFactoryId}/contractor`;
      } else {
        getUrl = `/factory/${this._currentFactoryId}/user`;
      }
      try {
        const res = await this.$axios.post(getUrl, this.addFields);
        let addElementId = res.data.data.id;
        let dropdownItems = H_user.setDropdownMenuList([res.data.data]);
        this.dropdownMenuItem = dropdownItems.concat(this.dropdownMenuItem);
        this.$emit('input', addElementId);
        this.$_dropdownClose();
      } catch (err) {
        alert(this.$t('新增發生錯誤'));
      }
    },
    $_scrollBottomGetDropdown() {
      const allScrollHeight = this.scrollTotalHeight - this.windowTotalHeight;
      const scrollHeight = this.position.scrollTop;
      if (scrollHeight / allScrollHeight > 0.9 && !this.articleLoading) {
        if (this.currentPage < this.lastPage) {
          this.currentPage += 1;
          this.$_getDropdownMenu();
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/dropdown-multiple-member-select-menu-button';
</style>
